import React from "react";
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getApi } from "../../api/endpoints";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { selectQueryParams, setQueryParams, updateQueryParams } from "../../ui/customerListingReducer";

const DeleteModal = (props) => {
  const {showDeleteModal, setShowDeleteModal, pincodeAttr} = props;
  const [deletePincodeApi] = getApi('deletePincode');
  const queryParams = useSelector(selectQueryParams);
  const dispatch = useDispatch();

  const handleModalClose = () => {
    setShowDeleteModal(false);
  }

  const onDeletePincodeClick = async () => {
    try{
      const response = await deletePincodeApi({id: `${pincodeAttr.id}`}).unwrap();
      setShowDeleteModal(false);
      toast.success(response.message || 'Pincode Deleted !');
      dispatch(updateQueryParams(setQueryParams(queryParams)));
    } catch(error) {
      setShowDeleteModal(true);
      toast.error(error.message || 'Something went wrong !');
    }
  }

  return <Modal
    show={showDeleteModal}
    onHide={handleModalClose}
    backdrop="static"
    keyboard={false}
    centered
  >
    <Modal.Header
      style={{ backgroundImage: 'linear-gradient(103deg, #49c12b 0, #197800 99%)' }}
      className="text-white"
      closeButton
    >
      <Modal.Title>Delete PIN Code</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className='text-center m-2 text-warning'><FontAwesomeIcon icon={faCircleExclamation} style={{ fontSize: '80px'}}/></div>
      <p className='h4 text-center my-3 opacity-75'>Are you sure ?</p>
      <p className='h6 text-center my-3 opacity-75 fw-normal'>You want to delete <span className="fw-bold">{pincodeAttr.pincode} - {pincodeAttr.area}</span> ?</p>
    </Modal.Body>
    <Modal.Footer>
      <button type="button" className="btn btn-sm add-button" style={{ width: "80px", fontSize: '16px' }} onClick={handleModalClose}>
        Cancel
      </button>
      <button type='submit' className='btn btn-sm remove-button' style={{ width: "80px", fontSize: '16px' }} onClick={(e) => {e.preventDefault(); onDeletePincodeClick()}}>
        Delete
      </button>
    </Modal.Footer>
  </Modal>
}

export default DeleteModal;
